/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
  // Локальные переменные
  let module = this;
  let sliderArticlesThumbs;

  module.sliderSettingsObject = {
    mainPageSlider: {
      params: {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        noSwiping: true,
      },
    },
    productsAppSlider: {
      params: {
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
        },
        slidesPerView: "auto",
        spaceBetween: 25,
        centeredSlides: true,
        allowSlidePrev: true,
        allowSlideNext: true,
        breakpoints: {
          767: {
            centeredSlides: false,
            slidesPerView: 4,
            allowSlidePrev: false,
            allowSlideNext: false,
            spaceBetween: 10,
          },
        },
        thumbs: {
          swiper: {
            el: ".swiper-container--products-app-text-slider",
            slidesPerView: 1,
            noSwiping: true,
            noSwipingClass: "swiper-no-swiping",
            autoHeight: true,
            breakpoints: {
              767: {
                slidesPerView: 4,
              },
            },
          },
        },
      },
    },
    productsWorkSlider: {
      params: {
        slidesPerView: "auto",
        loop: true,
        centeredSlides: true,
        spaceBetween: 30,
        allowSlidePrev: true,
        allowSlideNext: true,
        breakpoints: {
          768: {
            initialSlide: 1,
            slidesPerView: 3,
            loop: false,
            allowSlidePrev: false,
            allowSlideNext: false,
          },
        },
      },
    },
    productsUsefulSlider: {
      params: {
        slidesPerView: 1,
        autoHeight: true,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
      },
    },
    productsPlusUseSlider: {
      params: {
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        slidesPerView: 1,
        allowSlidePrev: true,
        allowSlideNext: true,
        breakpoints: {
          768: {
            loop: false,
            slidesPerView: 3,
            allowSlidePrev: false,
            allowSlideNext: false,
          },
        },
      },
    },
    productsBabyUseSlider: {
      params: {
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        slidesPerView: 1,
        allowSlidePrev: true,
        allowSlideNext: true,
        breakpoints: {
          768: {
            slidesPerView: 4,
            loop: false,
            allowSlidePrev: false,
            allowSlideNext: false,
          },
        },
      },
    },
    articlesSlider: {
      params: {
        on: {
          /**
           * Так как у нас пагинация должна находиться внутри слайда и всегда быть по краям у заголовка
           * то Я добавляю события клика при инициализации слайдера на все элементы с подходящими классами
           *
           */
          init: function (mySwiper) {
            /**
             * Локальная функция, которая срабатывает при изменении хеша.
             */
            function hashChange() {
              const hash = window.location.hash;
              const slideIndex = parseInt(hash.replace("#slide", ""), 10);
              const target = document.getElementById("js-article-slider");
              // const padding = window.matchMedia('(min-width: 1024px)') ? 150 : 94; // Настроил руками padding

              if (!isNaN(slideIndex)) {
                mySwiper.slideTo(slideIndex); // либо slideToLoop, если у вас включен loop

                if (target) {
                  itsoftApp.modules.animateScroll.callback.scrollTo(target, 0);
                  itsoftApp.modules.mobMenu.callback.closeMenu(); // Для закрытия мобильного меню
                }
              }
            }

            const leftButtons = document.querySelectorAll(
              ".js-article-slider-left"
            );
            const rightButtons = document.querySelectorAll(
              ".js-article-slider-right"
            );

            leftButtons.forEach((button) =>
              button.addEventListener("click", () => mySwiper.slidePrev())
            );
            rightButtons.forEach((button) =>
              button.addEventListener("click", () => mySwiper.slideNext())
            );

            if (window.location.hash) {
              hashChange();
            }

            window.addEventListener("hashchange", hashChange);
          },
          slideChange: function (swiper, progress) {
            //TODO: Доработать, если потребуется выравнивание по центу
            // const wrapper = sliderArticlesThumbs.$el[0].querySelector('.swiper-wrapper');
            // const slides = sliderArticlesThumbs.slides;
            // const slidesSizesGrid = sliderArticlesThumbs.slidesSizesGrid;
            // let activeSlideIndex;
            // let activeSlideWidth;
            //
            // let timeoutId = setTimeout(() => {
            //     for (let i = 0; i < slides.length; i++) {
            //         if (slides[i].classList.contains('swiper-slide-thumb-active')) {
            //             activeSlideIndex = i;
            //             clearTimeout(timeoutId);
            //             break;
            //         }
            //     }
            //     activeSlideWidth = slidesSizesGrid[activeSlideIndex]
            //
            //     let size = 0;
            //
            //     for (let j = 0; j < 7; j++) {
            //         size += slidesSizesGrid[j]
            //     }
            //
            //     console.log('sliderArticlesThumbs', sliderArticlesThumbs);
            //     console.log('activeSlideWidth', activeSlideWidth);
            //     console.log('size', size);
            // }, 300);

            sliderArticlesThumbs.slideNext()
          },
        },
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        autoHeight: true,
        thumbs: {
          swiper: {
            el: ".swiper-container--articles-tabs-slider",
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            noSwiping: true,
            breakpoints: {
              768: {
                noSwiping: false,
                spaceBetween: 30,
                // slidesPerView: 'auto',
                slidesPerView: 2,
                slidesPerGroup: 2,
              },
              1024: {
                noSwiping: false,
                loop: true,
                slidesPerView: "auto",
                spaceBetween: 60,
              },
            },
            on: {
              init: function (swiper) {
                sliderArticlesThumbs = swiper;
              },
            },
          },
        },
      },
    },
  };
});
